var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"inner",class:['branded-box', ("branded-box--" + _vm.direction), _vm.centered ? 'branded-box--centered' : '']},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }